<common-confirm></common-confirm>
<common-table2 #inboundTable *ngIf="inboundItemsList"
               [settings]="inboundItemsList"
               (gotData)="gotData($event)">
    <div row1>
        <button mat-raised-button color="accent"
                [disabled]="!canCreateInboundShipment()"
                *userAllowed="'browse_admin'"
                (click)="actionHandler({name:'shipment',data: null},'inbound')">
            <mat-icon>local_shipping</mat-icon>
            Create shipment
        </button>

        <button
                mat-raised-button
                color="primary"
                [disabled]="!canCreateInboundItem()"
                (click)="actionHandler(null, 'inbound')">
            Add inbound item
        </button>

        <button *ngIf="userService.validatePermissions(['browse_reports']) && canCreateInboundShipment()"
                mat-raised-button type="button" color="primary"
                (click)="onGenerateReport.emit(true)">
            Items report
        </button>

        <button mat-raised-button type="button"
                (click)="actionHandler({name: 'update_statuses',data:null},null)">
            Update statuses
        </button>
    </div>
</common-table2>
